export { default } from './InformaBanner';
